import React, { useState } from "react";
import { demoState } from "../tenancy";

/*
  PHASE 28 — shared demo hospital (shared website) ka chhota nishaan, har page par neeche-DAAYEIN kone me
  (baayein kone me sidebar ka Logout button dhak jaata tha; daayein Help button bottom 96px par, iske upar).

  19 Sep 2026 (user ka faisla): demo ka EK hi hospital hai aur uska login bahut logon ko diya jaata hai.
  Isliye yahan saaf likha hai: data sab dekhte hain, beech-beech me saaf hota hai, password/login badalna
  band hai, aur apna hospital shuru karna ho to hamein bataiye. Koi tarikh nahi.
  Asli rok backend par hai (password/login badalna 403). Demo na ho (ya Single mode) to kuch nahi dikhta.
*/
export default function DemoBadge() {
  const [open, setOpen] = useState(false);
  const d = demoState();
  if (!d) return null;

  return (
    <div className="demo-badge d-print-none">
      <button type="button" className="demo-pill" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <i className="bi bi-easel"></i> Shared demo
      </button>
      {open && (
        <div className="demo-card" role="dialog" aria-label="Demo details">
          <b>This is the shared demo hospital</b>
          <p>
            Try anything you like. Other people use this same demo, so <b>do not enter real patient data</b> —
            it is cleaned from time to time. Logins and passwords cannot be changed here.
          </p>
          <p>Liked it? Contact us and we will set up <b>your own hospital</b> with its own database.</p>
          <button type="button" className="demo-close" onClick={() => setOpen(false)}>Close</button>
        </div>
      )}
      <style>{`
        .demo-badge { position: fixed; right: 14px; bottom: 14px; z-index: 1080; font-family: 'Inter','Segoe UI',sans-serif; }
        .demo-pill { border: none; border-radius: 999px; padding: 7px 13px; font-size: 12.5px; font-weight: 700;
                     background: #fef3c7; color: #92400e; box-shadow: 0 4px 14px rgba(0,0,0,.12); cursor: pointer; }
        .demo-card { position: absolute; right: 0; bottom: 44px; width: min(310px, calc(100vw - 28px)); background: #fff;
                     border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px; box-shadow: 0 12px 30px rgba(0,0,0,.15);
                     font-size: 13px; color: #334155; }
        .demo-card p { margin: 6px 0 10px; line-height: 1.5; }
        .demo-close { border: 1px solid #cbd5e1; background: #fff; border-radius: 8px; padding: 5px 12px; cursor: pointer; font-size: 12.5px; }
      `}</style>
    </div>
  );
}
